export const COUNTRIES = [
  "Australia", "Brazil", "Burkina Faso", "Canada", "Chile", "China", "Colombia",
  "Democratic Republic of the Congo", "Egypt", "Finland", "Ghana", "Guinea", "India",
  "Indonesia", "Ivory Coast", "Kazakhstan", "Kenya", "Mali", "Mexico", "Mongolia",
  "Morocco", "Mozambique", "Namibia", "Nigeria", "Papua New Guinea", "Peru", "Philippines",
  "Russia", "Saudi Arabia", "Senegal", "Sierra Leone", "South Africa", "Sudan", "Sweden",
  "Tanzania", "Turkey", "Uganda", "United States", "Uzbekistan", "Zambia", "Zimbabwe", "Other",
];
